import React, { createContext, useState, useEffect, useCallback } from "react";
import { getHighRiskPatients } from "../services/getHighRiskPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const HighRiskContext = createContext();

// Por defecto solo activos (el backend también defaultea a true, pero lo
// dejamos explícito para que el switch "Include inactive" tenga efecto visible).
const INITIAL_FILTERS = {
  cipId: null,
  locationId: null,
  searchName: null,
  dateOfBirth: null,
  onlyActive: true,
  ppvEr: null,
  lace: null,
  bhStatus: null,
};

export const HighRiskProvider = ({ children }) => {
  const [highRiskPatients, setHighRiskPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const { isValid, authLoading } = useValidToken();

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => setFilters(INITIAL_FILTERS), []);

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getHighRiskPatients(filters);
        setHighRiskPatients(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, filters]);

  return (
    <HighRiskContext.Provider
      value={{
        highRiskPatients,
        loading,
        error,
        filters,
        updateFilter,
        resetFilters,
      }}
    >
      {children}
    </HighRiskContext.Provider>
  );
};
